import TopicPartitions from './TopicPartitions';

export default TopicPartitions;
